(function() {
  // 多语言提示文字
const cartMessages = {
  de: {
    removed: 'Aus Warenkorb entfernt',
    added: 'Zum Warenkorb hinzugefügt',
    updated: 'Warenkorb aktualisiert'
  },
  en: {
    removed: 'Removed from cart',
    added: 'Added to cart',
    updated: 'Cart updated'
  }
};

const currentLang = document.documentElement.lang?.split('-')[0] || 'de';
const cartText = cartMessages[currentLang] || cartMessages.en;


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickShop);
  } else {
    initQuickShop();
  }

  const ThemeEvents = window.ThemeEvents;

  // 更新购物车数量
  function updateCartCount(count) {
    const selectors = [
      '.cart-count-bubble', '.cart-count-bubble span',
      '.header__icon--cart .count', '[data-cart-count]',
      '.cart-count', '.js-cart-count', '.cart__count',
      '.site-header__cart-count', '.cart-bubble__text-count'
    ];
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.textContent = count;
        el.classList.toggle('hidden', count == 0);
      });
    });

    if (ThemeEvents && ThemeEvents.cartUpdate) {
      document.dispatchEvent(new CustomEvent(ThemeEvents.cartUpdate, {
        detail: { data: { itemCount: count, source: 'quick-shop' } }
      }));
    }
  }

  // 底部提示气泡
  function showCartNotice(message, color = 'rgba(0,128,0,0.9)') {
    const notice = document.createElement('div');
    notice.className = 'cart-notice';
    notice.style.cssText = `
      position: fixed;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%) translateY(20px);
      background: ${color};
      color: white;
      padding: 12px 20px;
      border-radius: 8px;
      font-size: 14px;
      opacity: 0;
      pointer-events: none;
      white-space: nowrap;  
      min-width: 200px;         
      max-width: 400px; 
      text-align: center; 
      transition: opacity 0.8s ease, transform 0.8s ease;
      z-index: 9999;
    `;
    notice.textContent = message;
    document.body.appendChild(notice);

    void notice.offsetWidth;

    notice.style.opacity = 1;
    notice.style.transform = 'translateX(-50%) translateY(0)';

    setTimeout(() => {
      notice.style.opacity = 0;
      notice.style.transform = 'translateX(-50%) translateY(-20px)';
    }, 3000);

    notice.addEventListener('transitionend', () => {
      if (notice.parentNode) notice.parentNode.removeChild(notice);
    });
  }

  // 获取产品数据，安全处理 403 / 网络错误
  async function fetchProduct(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) {
        console.warn(`无法获取产品 ${handle} 数据，HTTP ${res.status}`);
        return null;
      }
      return await res.json();
    } catch (err) {
      console.error('Failed to obtain product data', err);
      return null;
    }
  }

  // 添加/更新购物车商品，安全处理 403 / 网络错误
  async function updateCartForQty(variantId, qty) {
    try {
      const cart = await fetch('/cart.js').then(r => {
        if (!r.ok) throw new Error(`无法获取购物车，HTTP ${r.status}`);
        return r.json();
      });
      const item = cart.items.find(i => i.variant_id === variantId);

      if (qty <= 0) {
        if (item) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: `id=${item.id}&quantity=0`
          });
          const newCart = await fetch('/cart.js').then(r => r.json());
          updateCartCount(newCart.item_count);
          showCartNotice(cartText.removed, 'rgba(220,53,69,0.9)');
        }
        return false;
      }

      if (!item) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: `id=${variantId}&quantity=${qty}`
        });
        showCartNotice(cartText.added, 'rgba(0,128,0,0.9)');
      } else {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: `id=${item.id}&quantity=${qty}`
        });
        showCartNotice(cartText.updated, 'rgba(0,128,0,0.9)');
      }

      const newCart = await fetch('/cart.js').then(r => r.json());
      updateCartCount(newCart.item_count);

      // 第一次点击显示抽屉
      if (window.theme && theme.cartDrawer && typeof theme.cartDrawer.open === 'function') {
        theme.cartDrawer.open();
      }

      return true;
    } catch (err) {
      // console.warn('更新购物车失败，可能是权限或网络问题', err);
      // showCartNotice('购物车操作失败，请刷新页面或登录后重试', 'rgba(220,53,69,0.9)');
      return false;
    }
  }

  // 同步数量面板
  async function syncQtyPanel(panel, variantId, qtyInput) {
    const cart = await fetch('/cart.js').then(r => {
      if (!r.ok) return { items: [] };
      return r.json();
    });
    const item = cart.items.find(i => i.variant_id === variantId);
    const qty = item ? item.quantity : 1;
    qtyInput.value = qty;
    panel.style.display = qty > 0 ? 'flex' : 'none';

    if (!item && qty === 1) {
      await updateCartForQty(variantId, 1);
    }
  }

  // 初始化快速购买
  function initQuickShop() {
    const cards = document.querySelectorAll(
  '.card-gallery, [data-quick-shop-card]'
);

    cards.forEach(async card => {
      if (card.dataset.quickShopInitialized) return;

      const btn = document.createElement('div');
      btn.className = 'quick-shop-trigger';
      btn.innerHTML = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none">
        <path d="M12 5v14M5 12h14" stroke-linecap="round"/>
      </svg>`;
      const imageWrap =
      card.querySelector('.wishlist-image-wrap');

      if (imageWrap) {
        imageWrap.appendChild(btn);
      } else {
        card.appendChild(btn);
      }

      let productData = null;
      let currentVariant = null;
      let panel = null;

      const link = card.querySelector('a[href*="/products/"]');
      const handle = link?.getAttribute('href')?.match(/\/products\/([^\/?]+)/)?.[1];
      if (!handle) return;

      btn.addEventListener('click', async e => {
        e.stopPropagation();
        e.preventDefault();

        if (!productData) {
          productData = await fetchProduct(handle);
          if (!productData) return;
        }

        currentVariant = productData.variants.find(v => v.available) || productData.variants[0];
        if (!currentVariant) return;

        if (!panel) {
          panel = document.createElement('div');
          panel.className = 'quick-shop-panel';
          panel.innerHTML = `
            <button type="button" class="quick-shop-qty-btn" data-qty-minus>
              <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" width="16" height="16">
                <path d="M5 12h14" stroke-linecap="round"/>
              </svg>
            </button>
            <input type="number" class="quick-shop-qty-input" value="1" min="0" max="999" data-qty-input readonly>
            <button type="button" class="quick-shop-qty-btn" data-qty-plus>
              <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" width="16" height="16">
                <path d="M12 5v14M5 12h14" stroke-linecap="round"/>
              </svg>
            </button>
          `;
          const imageWrap =
          card.querySelector('.wishlist-image-wrap');

          if (imageWrap) {
            imageWrap.appendChild(panel);
          } else {
            card.appendChild(panel);
          }

          const qtyInput = panel.querySelector('[data-qty-input]');
          const minusBtn = panel.querySelector('[data-qty-minus]');
          const plusBtn = panel.querySelector('[data-qty-plus]');

          await syncQtyPanel(panel, currentVariant.id, qtyInput);

          qtyInput.addEventListener('keydown', e => e.preventDefault());
          qtyInput.addEventListener('paste', e => e.preventDefault());

          minusBtn.addEventListener('click', async () => {
            let qty = parseInt(qtyInput.value, 10) || 0;
            qty = Math.max(qty - 1, 0);
            qtyInput.value = qty;
            await updateCartForQty(currentVariant.id, qty);
            panel.style.display = qty > 0 ? 'flex' : 'none';
          });

          plusBtn.addEventListener('click', async () => {
            let qty = parseInt(qtyInput.value, 10) || 0;
            qty = Math.min(qty + 1, 999);
            qtyInput.value = qty;
            await updateCartForQty(currentVariant.id, qty);
            panel.style.display = 'flex';
          });
        } else {
          const qtyInput = panel.querySelector('[data-qty-input]');
          await syncQtyPanel(panel, currentVariant.id, qtyInput);
        }
      });

      card.dataset.quickShopInitialized = 'true';
    });
  }

  const observer = new MutationObserver(initQuickShop);
  observer.observe(document.body, { childList: true, subtree: true });
})();